import IIban from "@/module/main/dto/customer/IIban";

export default class Iban implements IIban {
    constructor(public iban?: string) {}
}
